import {
    isOptionForCreate,
    isOptionForSelectAll,
    SelectCreateButton,
    SelectGroupLabel,
    SelectItemAll,
    fabricIndex,
} from 'uikit';
import type {
    OptionForCreate,
    SelectAllItem,
    PropSize,
    GetOptionPropsResult,
    OptionProps,
    RenderItemProps,
} from 'uikit';

import React, { Fragment } from 'react';

interface ISearchableSelectDropdownItem {
    group:
        | OptionForCreate
        | {
              items: Array<SelectAllItem | any>;
              key: string | number;
              group?: any;
              groupIndex: number;
              checkedCount?: number;
              totalCount?: number;
          };
    size: PropSize;
    indent: 'normal' | 'increased';
    labelForCreate?: string;
    getOptionProps(props?: OptionProps<any>): GetOptionPropsResult;
    getGroupLabel?: (group: any) => string;
    renderItem: (props: RenderItemProps<any>) => JSX.Element | null;
}
export const SearchableSelectDropdownItem: React.FC<ISearchableSelectDropdownItem> = (props) => {
    const { group, size, indent, labelForCreate, getOptionProps, getGroupLabel, renderItem } = props;

    const getIndex = fabricIndex();

    if (isOptionForCreate(group)) {
        return (
            // eslint-disable-next-line react/jsx-key
            <SelectCreateButton
                size={size}
                labelForCreate={labelForCreate}
                inputValue={group.label}
                indent={indent}
                {...getOptionProps({ index: getIndex(), item: group })}
            />
        );
    }

    return (
        <>
            {group.group && getGroupLabel && (
                <SelectGroupLabel label={getGroupLabel(group.group)} size={size} indent={indent} />
            )}
            {group.items.map((item: any, i: any) => {
                if (isOptionForSelectAll(item)) {
                    return (
                        // eslint-disable-next-line react/jsx-key
                        <SelectItemAll
                            indent={indent}
                            size={size}
                            {...getOptionProps({ index: getIndex(), item })}
                            intermediate={
                                item.checkedCount && item.totalCount ? item.checkedCount !== item.totalCount : false
                            }
                            checked={item.checkedCount === item.totalCount}
                            countItems={item.checkedCount}
                            total={item.totalCount}
                        />
                    );
                }

                return (
                    <Fragment key={`${group.key}-${i}`}>
                        {renderItem({
                            item,
                            ...(getOptionProps({ index: getIndex(), item }) as any),
                        })}
                    </Fragment>
                );
            })}
        </>
    );
};

SearchableSelectDropdownItem.displayName = 'SearchableSelectDropdownItem';

export const MemoizedSearchableSelectDropdownItem = React.memo(SearchableSelectDropdownItem);
